export const CLIENT_BASEURL = process.env.REACT_APP_CLIENT_BASEURL || "";
export const API_BASEURL = process.env.REACT_APP_BASEURL || "";
export const RETRY_ATTEMPTS = 3;
export const RETRY_INTERVAL = 1000;
